export default {
  loginPending: false,
  loginFailed: false,
  loginSucceeded: false,
  loginErrors: null,

  passwordResetPending: false,
  passwordResetFailed: false,
  passwordResetSucceeded: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js